import { render, staticRenderFns } from "./typeclassNew.vue?vue&type=template&id=149fe465&scoped=true"
import script from "./typeclassNew.vue?vue&type=script&lang=js"
export * from "./typeclassNew.vue?vue&type=script&lang=js"
import style0 from "./typeclassNew.vue?vue&type=style&index=0&id=149fe465&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149fe465",
  null
  
)

export default component.exports